import { mq, mqH, mqLandscape } from '../../utils/mediaQuery';

export const backgroundCarouselContainer = {
  overflow: 'visible!important',
  position: 'absolute!important',
  height: 240,
  bottom: 152,
  width: '100%',
  [`${mqLandscape}`]: {
    bottom: 80,
  },
  [`${mq('sm')} and ${mqH('xs')}`]: {
    bottom: 85,
    height: 230,
  },
  [mq('md')]: {
    bottom: 100,
  },
};
